import { Box, Button, MenuItem, TextField } from '@mui/material'

import React, { useCallback } from 'react'
import {
  useAtom,
  useAtomValue,
  useSetAtom,
} from 'infrastructure/state/jotai.wrapper'
import {
  availableDistrictPackagesAtom,
  selectedActionAtom,
  selectedFeaturePackageAtom,
} from 'shared/api/platformFeatures'

const AddFeatureButtons = () => {
  const packageName = useAtomValue(selectedFeaturePackageAtom)
  const setSelectedAction = useSetAtom(selectedActionAtom)
  const setAction = useCallback(
    (locked: boolean) => {
      setSelectedAction({ entityType: 'district', actionType: 'add', locked })
    },
    [setSelectedAction],
  )

  return (
    <Box>
      <div className="section-buttons">
        <Button
          onClick={() => setAction(false)}
          variant="outlined"
          color="secondary"
          disabled={!packageName}
        >
          Add default feature
        </Button>
      </div>
      <div className="section-buttons">
        <Button
          onClick={() => setAction(true)}
          variant="outlined"
          color="secondary"
          disabled={!packageName}
        >
          Add locked feature
        </Button>
      </div>
    </Box>
  )
}

export const AddDistrictPackages = () => {
  const [packageName, setPackageName] = useAtom(selectedFeaturePackageAtom)
  const availablePackages = useAtomValue(availableDistrictPackagesAtom)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: '1em',
        alignItems: 'center',
      }}
    >
      <Box style={{ maxWidth: 500, minWidth: 300 }}>
        <TextField
          value={packageName ?? ''}
          label="Select feature package"
          variant="outlined"
          onChange={(e) => setPackageName(e.target.value)}
          select
          size="small"
          fullWidth
        >
          {availablePackages.map((packageName) => {
            return (
              <MenuItem key={packageName} value={packageName}>
                {packageName}
              </MenuItem>
            )
          })}
        </TextField>
      </Box>
      <AddFeatureButtons />
    </Box>
  )
}
